var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowBackBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.99991H3.135L6.768 1.63991C7.122 1.21591 7.064 0.584909 6.64 0.231909C6.215 -0.122091 5.585 -0.0640909 5.232 0.359909L0.232 6.35991C0.193 6.40691 0.173 6.46191 0.144 6.51391C0.12 6.55591 0.091 6.59191 0.073 6.63791C0.028 6.75291 0.001 6.87391 0.001 6.99591C0.001 6.99691 0 6.99891 0 6.99991C0 7.00091 0.001 7.00291 0.001 7.00391C0.001 7.12591 0.028 7.24691 0.073 7.36191C0.091 7.40791 0.12 7.44391 0.144 7.48591C0.173 7.53791 0.193 7.59291 0.232 7.63991L5.232 13.6399C5.43 13.8769 5.714 13.9999 6 13.9999C6.226 13.9999 6.453 13.9239 6.64 13.7679C7.064 13.4149 7.122 12.7839 6.768 12.3599L3.135 7.99991H15C15.552 7.99991 16 7.55191 16 6.99991C16 6.44791 15.552 5.99991 15 5.99991Z",
    fill: "#1864AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBackBlue);
export default __webpack_public_path__ + "static/media/IconArrowBackBlue.301ecc2e49b48fb3e1fd1e8b4319b08a.svg";
export { ForwardRef as ReactComponent };